import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'index',
    redirect: '/all',
    meta: {
      title: '京东智能产业园碳排放监测平台'
    }
  },
  {
    path: '/all',
    name: 'all',
    component: () =>
      import ('../views/all.vue'),
    meta: {
      title: '京东智能产业园碳排放监测平台'
    }
  },
  {
    path: '/single',
    name: 'all',
    component: () =>
      import ('../views/single.vue'),
    meta: {
      title: '京东智能产业园碳排放监测平台'
    }
  }
]
const router = new VueRouter({
  mode: "hash",
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router